/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipReportExportStatusQueryResponse, AuditReportsGetGipReportExportStatusPathParams, AuditReportsGetGipReportExportStatus401, AuditReportsGetGipReportExportStatus403, AuditReportsGetGipReportExportStatus404 } from "../models/AuditReportsGetGipReportExportStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipReportExportStatus } from "../axios/auditReportsGetGipReportExportStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipReportExportStatusQueryKey = (id: AuditReportsGetGipReportExportStatusPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/reports/gip/report/:id/export-status', params: {id:id} }] as const

export type AuditReportsGetGipReportExportStatusQueryKey = ReturnType<typeof auditReportsGetGipReportExportStatusQueryKey>

export function auditReportsGetGipReportExportStatusQueryOptions(id: AuditReportsGetGipReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipReportExportStatusQueryKey(id)
        return queryOptions<AuditReportsGetGipReportExportStatusQueryResponse, ResponseErrorConfig<AuditReportsGetGipReportExportStatus401 | AuditReportsGetGipReportExportStatus403 | AuditReportsGetGipReportExportStatus404>, AuditReportsGetGipReportExportStatusQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipReportExportStatus(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export job status for report
 * {@link /audit-reports/v1/reports/gip/report/:id/export-status}
 */
export function useAuditReportsGetGipReportExportStatus<TData = AuditReportsGetGipReportExportStatusQueryResponse, TQueryData = AuditReportsGetGipReportExportStatusQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipReportExportStatusQueryKey>(id: AuditReportsGetGipReportExportStatusPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipReportExportStatusQueryResponse, ResponseErrorConfig<AuditReportsGetGipReportExportStatus401 | AuditReportsGetGipReportExportStatus403 | AuditReportsGetGipReportExportStatus404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipReportExportStatusQueryKey(id)
         

         const query = useQuery({
          ...auditReportsGetGipReportExportStatusQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipReportExportStatus401 | AuditReportsGetGipReportExportStatus403 | AuditReportsGetGipReportExportStatus404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}